var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout_login login_wrapper",attrs:{"id":"container"}},[_c('login-header'),_c('login'),_c('footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }